export const GET_OUT_OF_COUNTRY_USER_SETTING = "GET_OUT_OF_COUNTRY_USER_SETTING";
export const UPDATE_ACCESS_CODE = "UPDATE_ACCESS_CODE";
export const TOGGLE_ACCESS_CODE = "TOGGLE_ACCESS_CODE";
export const OPEN_OUT_OF_COUNTRY_DIALOG = "OPEN_OUT_OF_COUNTRY_DIALOG";
export const CLOSE_OUT_OF_COUNTRY_DIALOG = "CLOSE_OUT_OF_COUNTRY_DIALOG";
